<template>
  <div>
    <div v-if="!showDetail">
      <b-row>
        <b-col>
          <b-tabs content-class="mt-3">
            <b-tab title="조직 계정" active>
              <p></p>
              <h4>등록된 계정 목록</h4>
              <b-skeleton-wrapper :loading="loading">
                <template #loading>                  
                  <b-skeleton-table :rows="5" :columns="fields.length" :table-props="{ bordered: true, striped: true }" small/>
                </template>
                <b-table 
                  v-if="onComplete" 
                  :items="userList"
                  :fields="fields" 
                  :per-page="perPage"
                  :current-page="currentPage"
                  striped 
                  bordered 
                  hover
                  caption-top
                  @row-clicked="myRowClickHandler"
                >
                  <template #table-caption>
                    <b-button class="float-right" variant="dark" squared style="width:150px; margin-bottom: 0.5rem;" @click="register">
                      조직계정생성
                    </b-button>
                  </template>
                  <template #cell(userRoles)="data">
                    <b-button small size="sm" class="mr-1" variant="secondary" pill disabled v-for="role in data.value" :key="role">
                      {{ role }}
                    </b-button>
                  </template>
                  <template #cell(resetPassword)="data">
                    <!-- v-b-modal.modal-prevent-closing -->
                    <b-button smal size="sm" variant="secondary" @click="showModal = true" >
                       {{ "Reset" }}
                    </b-button>
                    <div>
                      <!-- modal id가 동일한 경우 테이블 row 수만큼 모달이 열려서 v-model을 사용하여 제어하고 있습니다. -->
                      <!-- id="modal-prevent-closing" -->
                      <b-modal
                        v-model="showModal"
                        ref="modal-reset-password"
                        title="Reset Password"
                        @show="resetModal"
                        @hidden="resetModal"
                        @ok="handleOk($event, data)"
                      >
                        <form ref="form" @submit.stop.prevent="handleSubmit">
                          <b-form-group
                            label="Password"
                            label-for="password-input"
                            invalid-feedback="Enter at least 8 letters"
                            valid-feedback="Looks good!"
                          >
                            <b-form-input
                              id="password-input"
                              v-model="passwordReset"
                              :state="passwordResetState"
                              required
                            />
                          </b-form-group>
                        </form>
                      </b-modal>
                    </div>
                  </template>
                  <template #cell(delete)="row">
                    <b-button smal size="sm" variant="danger" squared v-on:click="register(row)" style="cursor:pointer;" >
                      수정
                    </b-button>
                  </template>
                  <template v-slot:cell(no)="data">
                    {{ (currentPage-1)*perPage + (data.index+1) }}
                  </template>
                </b-table>
                <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="center" />
              </b-skeleton-wrapper>
            </b-tab>
          </b-tabs>
        </b-col>
      </b-row>
      </div>
      <div v-else>
        <p></p>
        <h4>사용자를 등록합니다.</h4>
        <UserDetailsVue :user_model="user_model" :record="selectedRow" :editMode="editMode" @OnClosed="onClosed" @OnRefresh="onRefresh" />
      </div>
    </div>

</template>

<script>
import UserDetailsVue from './CreateOrgDetails.vue';
import awsCognito from '../../../api/awscognito.js';
import hal from 'hateoas-hal-link-resolver';
import moment from 'moment';

export default {
  components: {
    UserDetailsVue
  },
  name: 'User',
  props: {
    caption: {
      type: String,
      default: 'User id'
    },
  },
  created() {
    this.$_loadingTimeInterval = null
  },
  mounted() {
    this.startLoading();
    this.search();
  },
  data: () => {
    return {
      onComplete: false,
      showDetail: false,
      loading: false,
      editMode: false,
      resetShow: false,
      perPage: 5,
      currentPage: 1,
      userList: [],
      passwordReset: '',
      showModal: false,
      fields: [
        { key: 'organizationName', label: '조직명', class: 'text-center' },
        { key: 'organizationPrefix', label: 'companyID', class: 'text-center' },
        { key: 'prefixType', label: 'prefixType', class: 'text-center' },
        { key: 'createdDt', label: 'Registed Date', thStyle: { width: "150px" },
          formatter: (value, key, item) => {
              try {
                if(value){
                  return moment(value).format('YYYY-MM-DD');
                }
              }catch(err) {
                return '';
              }
            } 
        },
        // { key: 'resetPassword', label: 'reset password', thStyle: { width: "150px" } },
        { key: 'delete', label: ''},
      ],
      alliance_fields: [
        { key: 'organizationName', label: '조직명', class: 'text-center' },
        { key: 'organizationPrefix', label: 'companyID', class: 'text-center' },
        { key: 'prefixType', label: 'prefixType', class: 'text-center' },
        { key: 'createdDt', label: 'Registed Date', thStyle: { width: "150px" },
          formatter: (value, key, item) => {
              try {
                if(value){
                  return moment(value).format('YYYY-MM-DD');
                }
              }catch(err) {
                return '';
              }
            } 
        },
        { key: 'delete', label: '', class: 'text-center', thStyle: { width: "100px" }, },
      ],
      alliance_datas: [],
      // alliance_fields: [
      //   { name: 'serviceid-e986a4be-6c85-488a-a901-793c18b6bcb3', serviceID: 'serviceid-e986a4be-6c85-488a-a901-793c18b6bcb3'},
      // ],
      user_model: {
        name: '',
        email: '',
        role: [],
        organization: '',
      },
      role_group: [],
      selectedRow: {
        userName: '',
        userEmail: '',
        userPassword: '',
        userDept: '',
        userRoles: [],
        selectRow: false,
      },
    }
  },
  methods: {
    startLoading() {
      this.loading = true
    },
    onRefresh() {
      this.startLoading();
      this.search();
    },
    clearLoadingTimeInterval() {
      clearInterval(this.$_loadingTimeInterval)
      this.$_loadingTimeInterval = null
    },
    async search() {

      const profile = await this.$profile();

      const org = profile._links.organization.href;
      console.log(org)
      // const org = await this.$getOrganization();
      try {
        const response = await this.$http.get(`api/organization?${this.pagination()}`);
        console.log(response)
        this.userList = response.data._embedded.organization;
      } catch (err) {
        this.makeToastError(err);
      }
      return this.userList;
    },
    pagination(ctx) {
      if (ctx) {
        return `?page=${ctx.currentPage - 1}&size=${ctx.perPage}`;
      }
      return ''
    },
    register(record) {
      const item = record.item;
      console.log('record', record)
      if (item && item.id) {
        // 수정 모드로 전환
        this.$router.push({ name: '조직수정', params: { id: item.id } });
      } else {
        // 등록 모드로 전환
        this.$router.push({ name: '조직등록' });
      }
    },
    async myRowClickHandler(record) {
      // console.log(record, )
      const url = hal(record, 'alliances');
      const response = await this.$http.get(url);
      this.alliance_datas = this.$hateaos(response).alliance;

      // this.register();
      // this.selectedRow = Object.assign({ selectRow: true }, record);
      // this.editMode = true;


    },
    deleteUser(row) {
      this.$bvModal.msgBoxConfirm('정말로 삭제하시겠습니까?', {
        title: '삭제 확인',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: '삭제',
        cancelTitle: '취소',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
      })
      .then(value => {
        if (value) {
          this.delete(row.item);
        }
      })
      .catch(err => {
        this.makeToastError(err);
      });
    },
    async delete(record){
      
      const url = `${hal(await this.$profile(), 'user')}/${record.id}`;
      try {
        await this.$http.delete(url);
        this.makeToast('success', `${record.userName} has been successfully deleted from KFT Food Trust System.`);
        this.onRefresh();
      } catch (err) {
        alert(err)
      }
    },
    onResetClick() {
      this.resetShow = true;
    },
    onClosed() {
      this.showDetail = false;
      this.editMode = false;
    },
    getCognitoUserSession() {
      // 화면 로딩 전에 로그인한 사람의 세션 정보 set
      const cognito = new awsCognito();
      cognito.cognito_user_get_session_promise()
      .then((session) => {
        this.user_model = {
            name: session.getIdToken().payload['cognito:username'],
            email: session.getIdToken().payload['email'],
            role: session.getIdToken().payload['cognito:groups'],
            organization: session.getIdToken().payload['custom:organization'],
          }
      })
      .catch((err) => {
        this.makeToastError(err);
      });
    },
    makeToast(variant, message) {
      this.$bvToast.toast(message, {
        title: `200 OK`,
        variant: variant,
        solid: true
      })
    },
    makeToastError(err) {
      this.$bvToast.toast(err.message, {
        title: `Alert Request Failure`,
        variant: 'danger',
        solid: true,
        noAutoHide: true
      })
    },
    resetModal() {
      this.passwordReset = ''
    },
    handleOk(bvModalEvent, data) {

      // Prevent modal from closing
      bvModalEvent.preventDefault()

      // Trigger submit handler
      return this.handleSubmit(data.item.userName)
    },
    handleSubmit(userName) {

      // Exit when the form isn't valid
      if (this.passwordReset.length < 8) {
        return;
      }
      this.onPasswordReset(userName);

      // Hide the modal
      this.$nextTick(() => {
        this.showModal = false;
      })
    },
    async onPasswordReset(userName) {

      const url = `api/user/resetPassword?username=${userName}&newPassword=${this.passwordReset}`;
        this.$http.get(url)
          .then(response => {
            this.makeToast('success', `${userName} password has been successfully reset.`);
          }).catch(err => {
            this.makeToastError(err);
          })
    },
  },
  beforeMount() {
    this.getCognitoUserSession();
  },
  computed: {
    rows() {
      return this.userList.length
    },
    passwordResetState(){
      return this.passwordReset.length >= 8;
    },
  },
  watch: {
    loading(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.clearLoadingTimeInterval()
        if (newValue) {
          this.$_loadingTimeInterval = setInterval(() => {
            this.loading = false;
            this.onComplete = true;
          }, 1000)
        }
      }
    },
  }
}
</script>
<style scoped>
  .table>>>tbody>tr>td {
    cursor: pointer;
  } 
</style>